import { render } from "./screens.vue?vue&type=template&id=0396ff72"
import script from "./screens.vue?vue&type=script&lang=js"
export * from "./screens.vue?vue&type=script&lang=js"

import "./screens.vue?vue&type=style&index=0&id=0396ff72&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__